var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWeight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39.361,
    height: 34.393,
    viewBox: "0 0 39.361 34.393",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-3106.596 -305.954)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3138.526,314.327a1.45,1.45,0,0,1,1.366,1.078c2.035,7.665,4.061,15.332,6.016,23.018a1.536,1.536,0,0,1-1.485,1.915c-9.133.014-30.241.008-36.475.006a1.355,1.355,0,0,1-1.3-1.713l6.232-23.229a1.355,1.355,0,0,1,1.3-1.008C3118.686,314.371,3136.48,314.284,3138.526,314.327Z",
    fill: "#004878"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3126.415,315.416a4.731,4.731,0,1,1,4.732-4.731A4.736,4.736,0,0,1,3126.415,315.416Zm0-8.036a3.3,3.3,0,1,0,3.306,3.3A3.309,3.309,0,0,0,3126.415,307.38Z",
    fill: "#004878"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2982.376,506.891l2.475,10.666.354,1.524",
    transform: "translate(154.246 -189.816)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2982.376,506.891l.5,2.151.071.307",
    transform: "translate(158.504 -171.762)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 1
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeight);
export default __webpack_public_path__ + "static/media/weight.e837f66db2583237ce9678e60a3f73ed.svg";
export { ForwardRef as ReactComponent };